import { Select, SelectProps } from 'antd'

export const TagInput = (props: SelectProps<string[]>) => {
  return (
    <Select
      {...props}
      mode="tags"
      open={false}
      suffixIcon={null}
      options={[]}
    />
  )
}
